import React from "react";
import ReactDOM from "react-dom/client";
import "./static/index.css";
import App from "./App";
import { register as registerServiceWorker } from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker({
  onSuccess: () => console.log("[PWA] App ist offline verfügbar."),
  onUpdate: () =>
    console.log("[PWA] Neue Version verfügbar – Seite neu laden."),
});
